import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { ConfidentialResourceAccessRequestPending } from '../../../confidentialResourceAccessRequest.utils';

import { ReviewRequestModal } from './ReviewRequestModal';

type ReviewRequestModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type ReviewRequestModalOpenerProps = {
   request: ConfidentialResourceAccessRequestPending;
   children: (renderProps: ReviewRequestModalOpenerRenderProps) => ReactElement;
};

export const ReviewRequestModalOpener = (props: ReviewRequestModalOpenerProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <ReviewRequestModal request={props.request} onClose={closeModal} /> : null}
      </>
   );
};
